//export const api = "http://localhost:8000";

export const api= "https://back.psihologija.hr";
